export default "__VITE_ASSET__BFsASLYr__"